import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent'
import AppBar from '../../commons/AppBar'
import SegmentButtons from '../../commons/SegmentButtons'
import Ws from '../../providers/Ws';
import CardsDynamic from '../../commons/CardsDynamic'
import Utils from '../../providers/Utils';
import { Fab, Grid, Divider, Button } from '@material-ui/core';
import AddProject from '../../commons/dialogs/AddProject'
import FromServer from './FromServer';
import GanttProiecteWeekView from '../../commons/GanttProiecteWeekView'
import GanttProiecteMonthView from '../../commons/GanttProiecteMonthView'
import avatar from '../../Pics/avatar.jpg'
import LocalStorage from '../../providers/LocalStorage';
import ButtonsModules from '../../commons/ButtonsModules'
import AlertNew from '../../commons/dialogs/AlertNew';
import DrepturiAcces from '../drepturiacces/DrepturiAcces';


export default class Projects extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            proiecte: [],
            isOpenInsert: false,
            strNumeProiect: this.dictionary.proiecte.numeProiect,
            dtStartDate: new Date(),
            dtFinishDate: new Date(new Utils().defaultDataPlus1Months()),
            objPerioadaGantt: {},
            listEtape: [],
            openDeleteProiect: false,
            openArchive: false,
            proiectSelectat: {},
            objUser: {},
            proiecteDrepturi: {}


        }
    }

    drepturiP = new DrepturiAcces()
    ws = new Ws()
    ls = new LocalStorage()

    componentDidMount() {
        this.getProiecte()
    }

   

    goToPage = (page) => {

        this.props.history.push(`/${page}`)
    }


    dataAzi = () => {
        let u = new Utils()

        let dataAzi = u.defaultData()

        if (this.dictionary.date === 'en') {
            return u.dataPrescurtataEng(dataAzi)
        } else {
            return u.dataPrescurtataRomana(dataAzi)
        }
    }


    



    getProiecte = async () => {
       

        let ws = new Ws();

        let u = new Utils();

        let fS = new FromServer();



    

        console.log('this.ls.GetUserPreferences() :>> ', this.ls.GetUserData());

        let _proiecte = ws.customSelect('select * from proiecte where isnull(sters,0) = @p1 order by id desc', {
            p1: 0
        })


        let _etape = fS.getEtapeAll()

        let _utilizatori = await ws.customSelect(`select d.id_proiect, d.id as id_linie, d.doar_citire, d.nivel_responsabil, d.drepturi_extinse, d.id_utilizator as id ,
        a.nume, a.poza, a.cost_minut, u.email, u.firma, a.id as id_angajat, dep.nume as nume_departament from proiecte_drepturi d left join useri u on d.id_utilizator = u.id
        left join angajati a on u.id = a.id_user 
        left join angajati_departamente ad on ad.id_angajat = a.id
        left join departamente dep on dep.id = ad.id_departament
        where isnull(u.inactiv,0) != 1 and isnull(d.sters,0) != 1 order by isnull(d.nivel_responsabil,3) asc`, {
            p1: ''
        })


      


        let [proiecte, etape, t, utilizatori] = await Promise.all([_proiecte, _etape, fS.getTaskuriAll(), _utilizatori, ])

        // console.log('etape :', etape);




        console.log('proiecte :', proiecte);
        console.log('u :>> ', utilizatori);

       

        if (proiecte.Succes) {

            // console.log('t :', t);


         




            let _proiecteDrepturi = await ws.customSelect(`select d.*, a.id_user from angajati_departamente d left join 
                                                 angajati a on a.id = d.id_angajat where d.id_departament in ( select id_departament from angajati_acces_departamente where id_angajat in 
                                                    (select id from angajati where id_user = @p1) and isnull(sters,0) != 1 ) and isnull(d.inactiv,0) != 1`,{
                p1:this.ls.GetUserData().InfoUser.IdUser
            })

            console.log('proiecteDrepturi :>> ', _proiecteDrepturi);


            let angajatiProiecte = []

            if(_proiecteDrepturi.Succes){

                console.log('vede proiecte angajati :>> ', _proiecteDrepturi);

                for(let i = 0 , n =  _proiecteDrepturi.Content.length ; i < n ;i++){

                    if(_proiecteDrepturi.Content[i].id_user){

                        angajatiProiecte.push(_proiecteDrepturi.Content[i].id_user)
                    }

                }
            }

            console.log('angajatiProiecte :>> ', angajatiProiecte);

            let cloneEtape = [...etape]


            let cloneUseri = [...utilizatori.Content]

            for (let i = 0, n = cloneUseri.length; i < n; i++) {

                cloneUseri[i].show_tag = false
            }




            let cloneTaskuri = [...t]

            let counter2 = cloneEtape.length



            for (let i = 0; i < counter2; i++) {
                let filterTaskuri = cloneTaskuri.filter(t => t.id_etapa_proiect === cloneEtape[i].id)


                // console.log('cloneTaskuri :', cloneTaskuri);


                filterTaskuri = filterTaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(cloneEtape[i].durata_pana_la) && new Date(u.ParseDataFromSql(t.pana_cand_data)) < new Date(cloneEtape[i].durata_pana_la)))

                filterTaskuri = filterTaskuri.filter(t => t.pana_cand_data !== null)

                filterTaskuri = filterTaskuri.filter(t => t.statusul !== 'Finalizat')

                // console.log('filterTaskuri :', filterTaskuri);

                // let taskuriTrecute = filterTaskuri.filter(t => new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date())

                // let taskuriInViitor = filterTaskuri.filter(t => new Date(u.ParseDataFromSql(t.cand_data)) > new Date())



                cloneEtape[i].taskuri = cloneTaskuri.filter(t => t.id_etapa_proiect === cloneEtape[i].id)
                cloneEtape[i].taskuri_finalizate = cloneEtape[i].taskuri.filter(t => t.statusul === 'Finalizat')
                if (cloneEtape[i].taskuri.length === 0) {
                    cloneEtape[i].procent_completare = 100
                } else {

                    cloneEtape[i].procent_completare = (cloneEtape[i].taskuri_finalizate.length * 100) / cloneEtape[i].taskuri.length
                }


                if (cloneEtape[i].taskuri_finalizate.length >= 1) {
                    cloneEtape[i].color = 'rgb(24 166 59)'

                } else if (cloneEtape[i].taskuri.length === 0) {
                    cloneEtape[i].color = 'rgb(225 225 224)'
                }

                else {
                    cloneEtape[i].color = 'rgb(209	209	208	)'
                }

                // if (filterTaskuri.length > 0) {
                //     if (taskuriTrecute.length > 0) {
                //         cloneEtape[i].color = 'rgb(209	209	208	)'
                //     } else if (filterTaskuri.length === taskuriInViitor.length) {
                //         cloneEtape[i].color = 'rgb(209	209	208	)'
                //     } else {
                //         cloneEtape[i].color = 'rgb(209	209	208	)'
                //     }



                // } else {
                //     cloneEtape[i].color = 'rgb(24 166 59)'
                // }



                //     cloneEtape[i].color = '#ff3f3f'
                // }else if (filterTaskuri.length > 0){
                //     cloneEtape[i].color = 'rgb(247, 167, 16)'
                // }else{
                //     cloneEtape[i].color = '#7ad13a'
                // }

            }



            // console.log('cloneEtape :', cloneEtape);

            let cp = [...proiecte.Content]

            let cloneProiecte = []

            let proiecteDrepturi = this.drepturiP.getAccesProiecte()

            console.log('proiecteDrepturi :>> ', proiecteDrepturi);

            for (let i = 0, n = proiecteDrepturi.length; i < n; i++) {
                let idx = cp.findIndex(c => c.id === proiecteDrepturi[i].id_proiect)


                if (idx !== -1) {

                    cp[idx].drepturi = proiecteDrepturi[i]

                    cloneProiecte.push(cp[idx])
                }
            }

            let counter = cloneProiecte.length

            let perioadaDeLa = u.defaultData()

            let perioadaPanaLa = u.defaultDataPlus3Months();

            for (let i = 0; i < counter; i++) {
                let procentProiect = 0
                let taskuriProiect = cloneTaskuri.filter(t => t.id_proiect === cloneProiecte[i].id)
                let taskuriFinalizateProiect = taskuriProiect.filter(t => t.statusul === 'Finalizat')



                cloneProiecte[i].perioada_dela = u.ParseDataFromSql(cloneProiecte[i].perioada_dela)
                cloneProiecte[i].perioada_panala = u.ParseDataFromSql(cloneProiecte[i].perioada_panala)

                if (taskuriProiect.length === 0) {
                    cloneProiecte[i].procent_completare = 0
                } else {
                    cloneProiecte[i].procent_completare = ((taskuriFinalizateProiect.length * 100) / taskuriProiect.length).toFixed(2) + '%'
                }

                cloneProiecte[i].taskuri = taskuriProiect
                cloneProiecte[i].taskuri_finalizate = taskuriFinalizateProiect
                cloneProiecte[i].utilizatori = cloneUseri.filter(ut => ut.id_proiect === cloneProiecte[i].id)



            }

            for (let i = 0; i < counter; i++) {
                if (new Date(cloneProiecte[i].perioada_dela) < new Date(perioadaDeLa)) {
                    perioadaDeLa = cloneProiecte[i].perioada_dela
                }

                if (new Date(cloneProiecte[i].perioada_panala) > new Date(perioadaPanaLa)) {
                    perioadaPanaLa = cloneProiecte[i].perioada_panala
                }
            }

            // console.log('perioadaDeLa :', perioadaDeLa);
            // console.log('perioadaPanaLa :', perioadaPanaLa);



            console.warn('Cloneproiecte :', cloneProiecte);


            let drepturiProiecte = await this.drepturiP.getDrepturiAplicatie()

            if(this.ls.GetUserData().InfoUser.IsAdmin !== 1 && drepturiProiecte.acces_extins_proiecte){
                console.log('cloneProiecte :>> ', cloneProiecte);
                console.log('angajatiProiecte :>> ', angajatiProiecte);

                angajatiProiecte.push(Number(this.ls.GetUserData().InfoUser.IdUser))


                let proiecteFilter = []





                for(let i = 0 , n = cloneProiecte.length ; i < n ; i++){

                        let idxA = angajatiProiecte.indexOf(cloneProiecte[i].id_user_responsabil)


                        let idxD = cloneProiecte[i].utilizatori.findIndex(a => Number(a.id) === Number(this.ls.GetUserData().InfoUser.IdUser))

                        console.log('idxD :>> ', idxD);

                        if(idxA !== -1){
                            proiecteFilter.push(cloneProiecte[i])
                        }else if(idxD !== -1){
                            proiecteFilter.push(cloneProiecte[i])
                        }
                }



                console.log('proiecteFilter :>> ', proiecteFilter);

                cloneProiecte = proiecteFilter
            }

            console.log('cloneProiecte :>> ', cloneProiecte);

        console.log('drepturiProiecte :>> ', drepturiProiecte);
                this.setState({
                    proiecte: cloneProiecte,
                    objPerioadaGantt: { dtPerioadaDeLa: perioadaDeLa, dtPerioadaPanaLa: perioadaPanaLa },
                    listEtape: cloneEtape,
                    proiecteDrepturi: drepturiProiecte
                })
            




        }
    }


    onProiectSelectat = (p) => {

        this.props.history.push(`/projectdetails/${p.id}/0`)
    }

    addProject = async () => {

        let u = new Utils()
        let ls = new LocalStorage().GetUserData()

        let date = u.transformDataForSql(this.state.dtStartDate)



        let dateSf = u.transformDataForSql(this.state.dtFinishDate)



        console.log('ls :>> ', ls.InfoUser.IdUser);


        let objToInsert = {
            titlu: ' ',
            perioada_dela: date,
            perioada_panala: u.transformDataForSql(dateSf),
            token: u.generateId(),
            id_user_responsabil:ls.InfoUser.IdUser
        }

        console.log('objToInsert :', objToInsert);


        let insert = await new FromServer().insertProject(objToInsert)

        if (insert.success) {
            this.props.history.push(`/newproject/${insert.obj[0].id}`)
        }
    }

    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>Astazi:{this.dataAzi()} </span>
        </div>)

        return rez
    }

    returnButton = () => {
        let rez = []



        if(this.state.proiecteDrepturi.acces_extins_proiecte){
            rez.push(<div key={1}>
                <Button style={{ display: this.props.displayInsert === 1 ? 'none' : 'inline-flex', padding: 10, backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={this.addProject}  >
                    <i className='material-icons pm-round-button-text'>add</i>
                                  {this.dictionary.proiecte.proiectNou}
                                </Button>
            </div>)
        }

      

        return rez
    }


    openArchiveProiect = (p) => {

        console.log('p :>> ', p);

        let accProiecte = this.drepturiP.getDrepturiAplicatie()

        console.log('accProiecte :>> ', accProiecte);

        if (accProiecte.acces_extins_proiecte) {
            this.setState({
                proiectSelectat: p,
                openArchive: true
            })
        }


    }

    openDeleteProiect = (p) => {

       
                this.setState({
                    proiectSelectat: p,
                    openDeleteProiect: true
                })
        
    }


    arhiveaza = async () => {

        let proiect = { ...this.state.proiectSelectat }

        console.log('proiect :>> ', proiect);

        let arhvP = await this.ws.update('proiecte', { sters: 1 }, { id: proiect.id })

        if (arhvP.Succes) {
            this.setState({
                proiectSelectat: {},
                openArchive: false
            }, () => {
                this.getProiecte()
            })
        }

    }

    stergeProiect = async () => {

        let proiect = { ...this.state.proiectSelectat }

        console.log('proiect :>> ', proiect);

        let arhvP = await this.ws.update('proiecte', { sters: 2 }, { id: proiect.id })

        if (arhvP.Succes) {
            this.setState({
                proiectSelectat: {},
                openDeleteProiect: false
            }, () => {
                this.getProiecte()
            })
        }

    }


    showUserTag = (u, p) => {

        let cloneUseri = [...p.utilizatori]

        // let cloneUseri = [...this.state.useri]

        let idx = cloneUseri.findIndex(us => us.id === u.id)

        if (idx !== -1) {
            cloneUseri[idx].show_tag = true

            this.setState({ useri: cloneUseri })
        }

    }

    hideUserTag = (u, p) => {
        // let cloneUseri = [...this.state.useri]

        let cloneUseri = [...p.utilizatori]

        let idx = cloneUseri.findIndex(us => us.id === u.id)

        if (idx !== -1) {
            cloneUseri[idx].show_tag = false

            this.setState({ useri: cloneUseri })
        }
    }
    render() {
        return (
            <div>

                <AlertNew
                    open={this.state.openArchive}
                    dialogClose={() => { this.setState({ openArchive: false }) }}
                    title={this.dictionary.proiecte.archiveProject}
                    mesaj={this.dictionary.proiecte.archiveProjectMessage}
                    yesFunction={this.arhiveaza}
                    deleteP={true}
                />

                <AlertNew
                    open={this.state.openDeleteProiect}
                    dialogClose={() => { this.setState({ openDeleteProiect: false }) }}
                    title= {this.dictionary.proiecte.deleteProject}
                    mesaj={this.dictionary.proiecte.deleteProjectMessage}
                    yesFunction={this.stergeProiect}
                    deleteP={true}
                />

                <AppBar history={this.props.history} title={this.returnButton()} appBarButtons={this.buildAppBarButtons()} />



                {/* <ButtonsModules
                    scop='Management Proiecte'
                    history={this.props.history} /> */}



                {/* <Divider className="pm-divider" /> */}

                <AddProject
                    open={this.state.isOpenInsert}
                    dialogClose={() => { this.setState({ isOpenInsert: false }) }}
                    strNume={this.state.strNumeProiect}
                    numeChange={(ev) => { this.setState({ strNumeProiect: ev.target.value }) }}
                    startDate={this.state.dtStartDate}
                    changeStartDate={(ev) => { this.setState({ dtStartDate: ev }) }}
                    limba={this.dictionary}
                    addProject={this.addProject}
                    finishDate={this.state.dtFinishDate}
                    changeFinishDate={(ev) => { this.setState({ dtFinishDate: ev }) }}
                    focusName={() => { this.setState({ strNumeProiect: '' }) }}
                />


                <div style={{ position: 'relative' }}>


                    <div style={{ maxWidth: 1200, textAlign: 'left', margin: 'auto', paddingLeft: 50 }}>
                        <h1 className='pm-title-big'>{this.dictionary.proiecte.projectManagement}</h1>
                    </div>

                    {/* {this.state.proiecte.length > 0 && 
            <div style={{height:'40vh', overflow:'scroll', width:'95%', margin:'auto'}}>
            <CardsDynamic elemente={this.state.proiecte}
                          onlyColumns = {{title:'titlu', content:'descriere' }}
                          onElementClick ={this.onProiectSelectat}
                          dictionary={this.dictionary}
                          />
            
            
            
            </div>  } */}



                    <div style={{ width: '100%', overflow: 'hidden', maxWidth: 1200, position: 'relative', margin: 'auto' }}>

                        {/* <div style={{ height: '100%', position: 'absolute', left: 0, right: 0, margin: 'auto', width: 1, backgroundColor: '#e0e0e0' }}></div> */}
                        {/* <div  style={{ marginTop:20, overflowX:'scroll', overflowY:'hidden', textAlign:'left', height:'100%', display:'flex', position:'relative'}}> */}



                        {/* <GanttProiecteWeekView
                    dictionary={this.dictionary}
                    objPerioadaGantt={this.state.objPerioadaGantt}
                    listEtape={this.state.listEtape}
                    listProiecte={this.state.proiecte}
                    history={this.props.history}
                    /> */}

                        <GanttProiecteMonthView
                            objPerioadaGantt={this.state.objPerioadaGantt}
                            listEtape={this.state.listEtape}
                            listProiecte={this.state.proiecte}
                            history={this.props.history}
                            dictionary={this.dictionary}
                            idProiect={[{ id: 'abc' }]}
                            openArchiveProiect={this.openArchiveProiect}
                            openDeleteProiect={this.openDeleteProiect}
                            showUserTag={this.showUserTag}
                            hideUserTag={this.hideUserTag}

                        />



                        {/* </div> */}
                    </div>
                </div>
            </div>
        );
    }
}